import urlToFile from '@/utils/urlToFile';
import {onFileInput} from '@/views/content-studio/components/file-upload/utils';

export default async function downloadAndUploadAsset(
  assetUrl: string,
  fileName: string
) {
  const blob = await urlToFile(assetUrl, fileName);
  const file = new File([blob], fileName, {type: 'video/mp4'});
  onFileInput([file], 'asset-upload', 'asset-upload', {
    started: () => {},
    ended: () => {},
  });
}
